import { TYPES } from './mutations';
import api from './api';

const GENERIC_TYPES = {
  FETCH_ORDER: 'orderDetails',
  UPDATE_ADDRESS: 'addressDetails',
  RECHARGE: 'recharge',
  CREATE_OPEN_ENDED_ORDER: 'openEndedDetails',
};

function createOpenEndedOrder({ commit }, { body, apiKey }) {
  return new Promise(async (resolve, reject) => {
    commit(TYPES.GENERIC_REQUEST, GENERIC_TYPES.CREATE_OPEN_ENDED_ORDER);
    try {
      const { data } = await api.createOpenEndedOrder(body, apiKey);
      commit(TYPES.CREATE_OPEN_ENDED_ORDER_SUCCESS, data);
      resolve(data);
    } catch (error) {
      commit(TYPES.GENERIC_ERROR, {
        type: GENERIC_TYPES.CREATE_OPEN_ENDED_ORDER,
        message: (error.response && error.response.data.error.errors[0].message) || 'Something went wrong when trying to create an order.',
      });
      reject(error);
    }
  });
}

export default {
  createOpenEndedOrder,
};
